import { popupModel } from 'src/components/complex';
import { InfoAlert } from './InfoAlert';
import { BaseAlert } from './BaseAlert';
import { WarnAlert } from './WarnAlert';
import { MobileInfoAlert } from './MobileInfoAlert';

const typeComponents = {
  BASE: BaseAlert,
  INFO: InfoAlert,
  WARN: WarnAlert,
  MOBILE_INFO: MobileInfoAlert
};

class AlertManager {
  TYPES = {
    BASE: 'BASE',
    INFO: 'INFO',
    WARN: 'WARN',
    MOBILE_INFO: 'MOBILE_INFO'
  };
  /**
   * @param type
   * @param props
   *   close: true|false - > show close button
   *   title: string
   *   body:string
   *   actionButton: {
   *     label:string,
   *     loadingLabel:string,
   *     action:({hide, setLoading})=>{}
   *   }
   *   cancelButton:{...}
   * @param otherParams
   */
  popup = (type, props, otherParams = {}) => {
    const component = typeComponents[type] || '';
    popupModel.setActivePopup(type, {
      active: true,
      component,
      ...otherParams,
      props: props
    });
  };
}

export default new AlertManager();
